const NODE16 = {
  NAME: 'IR-DHT11',
  INPUT1: {
    NAME: 'NODE16_INPUT1_NAME',
    TYPE: 'temperatureSensor',
    ICON: 'temperature',
    PARAMETER_ID: 0x8120,
  },
  INPUT2: {
    NAME: 'NODE16_INPUT2_NAME',
    TYPE: 'humiditySensor',
    ICON: 'humidity',
    PARAMETER_ID: 0x8121,
  },
  IR: {
    PARAMETER_ID: 0x4700,
  },
  RF: {
    PARAMETER_ID: 0x4600,
  },
  TEMPERATURE: {
    NAME: 'NODE16_TEMPERATURE_NAME',
    TYPE: 'internalTemperature',
    ICON: 'temperature',
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
}
NODE16.DEFAULT_INSTRUCTIONS = [];

NODE16.devices = [
  {
    name: "Type A",
    icon: "remoteControl",
    idLength: 32,
    channels: [
      [0,0,0,1,0,0,0],
      [0,1,0,1,0,1,0],
      [0,0,1,1,0,0,1],
      [1,0,0,1,1,0,0],
    ],
    learnPacket: [0,0,0,1,0,0,0],
    lowThrUs: 360,
    highThrUs: 725,
    startSeq: [4850, 1500],
    endThrUs: 7850,
    beforeEnd: 1,
  },
  {
    name: "Type B",
    icon: "remoteControl",
    idLength: 32,
    channels: [
      [0,0,0,1,0,0,0],
      [0,1,0,1,0,1,0],
      [0,0,1,1,0,0,1],
      [1,0,0,1,1,0,0],
    ],
    learnPacket: [1,1,0,0,1,1,0],
    lowThrUs: 360,
    highThrUs: 725,
    startSeq: [4850, 1500],
    endThrUs: 7850,
    beforeEnd: 0,
  },
  {
    name: "Type C",
    icon: "remoteControl",
    idLength: 20,
    channels: [
      [0,0,0,1],
      [0,0,1,0],
      [0,1,0,0],
      [1,0,0,0],
    ],
    learnPacket: [0,0,0,1],
    lowThrUs: 360,
    highThrUs: 1070,
    startSeq: [350, 11000],
    endThrUs: 0,
  },
  {
    name: "Type D",
    icon: "remoteControl",
    idLength: 20,
    channels: [
      [0,0,0,1],
      [0,0,1,0],
      [0,1,0,0],
      [1,0,0,0],
    ],
    learnPacket: [0,0,1,0],
    lowThrUs: 210,
    highThrUs: 645,
    startSeq: [210, 6657],
    endThrUs: 0,
  },
];

export default NODE16;